import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { DataTable } from "@life-line-lab/components-react";
import { Row, Col, Spin } from "antd";
import moment from "moment";
import "./order-details.scss";
import { EditOutlined, LoadingOutlined } from "@ant-design/icons";
import { formatDate } from "Helpers/format-date";
import { ParcelTypeEnums } from "Data/order";

const OrderInformation: FC<any> = (props) => {
  const { orderDetails, handleEditDeliveryDate, handleEditPickupDateTime } = props || {};
  const estimatedPickupDateTime =
    orderDetails?.firstMileInfoData?.pickupData?.pickupDate;
  const { t } = useTranslation();

  const RowOne = () => {
    return (
      <>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.orderDate")} </label>
            </Col>
            <Col span={24}>
              <div>
                {moment(orderDetails?.createdAt).format("DD-MM-YYYY") || "-"}
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.deliveryDate")} </label>
            </Col>
            <Col span={24}>
              <div className="pov-edit-container">
                <div>
                  {moment(orderDetails?.deliveryDate).format("DD-MM-YYYY") ||
                    "-"}
                </div>
                {orderDetails?.deliveryDate && (
                  <span
                    className="pov-edit"
                    onClick={() =>
                      handleEditDeliveryDate(
                        orderDetails?._id,
                        orderDetails?.deliveryDate,
                      )
                    }
                  >
                    <EditOutlined />
                  </span>
                )}
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.deliveryType")} </label>
            </Col>
            <Col span={24}>
              <div>{orderDetails?.deliveryTypeName}</div>
            </Col>
          </Row>
        </Col>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.serviceType")} </label>
            </Col>
            <Col span={24}>
              <div>{orderDetails?.serviceTypeName}</div>
            </Col>
          </Row>
        </Col>
      </>
    );
  };

  const RowTwo = () => {
    return (
      <>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.sender")} </label>
            </Col>
            <Col span={24}>
              <div>{orderDetails?.senderInfo?.fullName}</div>
            </Col>
          </Row>
        </Col>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.senderAddress")} </label>
            </Col>
            <Col span={24}>
              <div>
                {orderDetails?.senderInfo?.address?.street1}{" "}
                {orderDetails?.senderInfo?.address?.street2},
              </div>
              <div>
                {orderDetails?.senderInfo?.address?.postcode}{" "}
                {orderDetails?.senderInfo?.address?.city},
              </div>
              <div>
                {orderDetails?.senderInfo?.address?.state}{" "}
                {orderDetails?.senderInfo?.address?.country}
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title">
                {" "}
                {t("label.senderContactInformation")}{" "}
              </label>
            </Col>
            <Col span={24}>
              <div>+{orderDetails?.senderInfo?.contactNumber?.fullNumber}</div>
              <div>{orderDetails?.senderInfo?.contactEmail}</div>
            </Col>
          </Row>
        </Col>
      </>
    );
  };

  const RowThree = () => {
    return (
      <>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.recipient")} </label>
            </Col>
            <Col span={24}>
              <div>{orderDetails?.receiverInfo?.fullName}</div>
            </Col>
          </Row>
        </Col>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.recipientAddress")} </label>
            </Col>
            <Col span={24}>
              <div>
                {orderDetails?.receiverInfo?.address?.street1}{" "}
                {orderDetails?.receiverInfo?.address?.street2},
              </div>
              <div>
                {orderDetails?.receiverInfo?.address?.postcode}{" "}
                {orderDetails?.receiverInfo?.address?.city},
              </div>
              <div>
                {orderDetails?.receiverInfo?.address?.state}{" "}
                {orderDetails?.receiverInfo?.address?.country}
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title">
                {" "}
                {t("label.recipientContactInformation")}{" "}
              </label>
            </Col>
            <Col span={24}>
              <div>
                +{orderDetails?.receiverInfo?.contactNumber?.fullNumber}
              </div>
              <div>{orderDetails?.receiverInfo?.contactEmail}</div>
            </Col>
          </Row>
        </Col>
      </>
    );
  };

  const RowFour = () => {
    return (
      <>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.returnInfo")} </label>
            </Col>
            <Col span={24}>
              <div>{orderDetails?.senderInfo?.fullName}</div>
            </Col>
          </Row>
        </Col>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title">
                {" "}
                {t("label.returnContactInformation")}{" "}
              </label>
            </Col>
            <Col span={24}>
              <div>+{orderDetails?.senderInfo?.contactNumber?.fullNumber}</div>
              <div>{orderDetails?.senderInfo?.contactEmail}</div>
            </Col>
          </Row>
        </Col>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.pickUpDateAndTime")} </label>
            </Col>
            <Col span={24}>
              <div className="pov-edit-container">
                {formatDate(estimatedPickupDateTime, "DD/MM/YYYY hh:mm a")}
                {estimatedPickupDateTime && (
                  <span
                    className="pov-edit"
                    onClick={() =>
                      handleEditPickupDateTime(
                        orderDetails?._id,
                        estimatedPickupDateTime,
                      )
                    }
                  >
                    <EditOutlined />
                  </span>
                )}
              </div>
            </Col>
          </Row>
        </Col>
      </>
    );
  };

  return (
    <div className="dm-put-content">
      <Row gutter={[16, 24]}>
        <RowOne />
        <RowTwo />
        <RowThree />
        <RowFour />
      </Row>
    </div>
  );
};

const OrderSpecifications = ({ orderDetails }) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("label.parcels"),
      dataIndex: "index",
      render: (item: any, record: any, index: any) => (
        <>{record?.number ?? index + 1}</>
      ),
    },
    {
      title: t("label.content"),
      dataIndex: "content",
    },
    {
      title: t("label.category"),
      dataIndex: "name",
    },
    {
      title: t("label.goodsValue"),
      dataIndex: "goodsValue",
    },
    {
      title: t("label.trackingNo"),
      render: () => {
        return <>{orderDetails.trackingNumber}</>;
      },
    },
  ];

  const RowOne = () => {
    return (
      <>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.length")} </label>
            </Col>
            <Col span={24}>
              <div>{orderDetails?.dimension?.length} cm</div>
            </Col>
          </Row>
        </Col>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.width")} </label>
            </Col>
            <Col span={24}>
              <div>{orderDetails?.dimension?.width} cm</div>
            </Col>
          </Row>
        </Col>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.height")} </label>
            </Col>
            <Col span={24}>
              <div>{orderDetails?.dimension?.height} cm</div>
            </Col>
          </Row>
        </Col>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.weight")} </label>
            </Col>
            <Col span={24}>
              <div>{orderDetails?.weight} kg</div>
            </Col>
          </Row>
        </Col>
      </>
    );
  };

  const RowTwo = () => {
    return (
      <>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.remarks")} </label>
            </Col>
            <Col span={24}>
              <div>
                {orderDetails?.remarks ? orderDetails.remarks : "No remarks"}
              </div>
            </Col>
          </Row>
        </Col>
      </>
    );
  };

  const RowThree = () => {
    return (
      <Col span={24}>
        <DataTable columns={columns} dataSource={orderDetails?.parcels} />
      </Col>
    );
  };

  return (
    <div className="dm-put-content">
      <Row gutter={[16, 24]}>
        <RowOne />
        <RowTwo />
        <RowThree />
      </Row>
    </div>
  );
};

const OrderSpecificationsSplitShipment = ({ orderDetails }) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("label.parcels"),
      dataIndex: "runningNumber",
    },
    {
      title: t("label.category"),
      dataIndex: "parcels",
      render: (parcels: any[]) => {
        return <>{parcels[0].name}</>;
      },
    },
    {
      title: t("label.goodsValue"),
      dataIndex: "parcels",
      render: (parcels: any[]) => {
        return <>{parcels[0].goodsValue}</>;
      },
    },
    {
      title: t("label.trackingNo"),
      dataIndex: "trackingNumber",
      render: (trackingNumber: string, record: any) => {
        return <>{`${trackingNumber}/${record.runningNumber}`}</>;
      },
    },
    {
      title: t("label.volume"),
      dataIndex: "dimension",
      render: (dimension: any) => {
        return (
          <>{`${dimension.length} x ${dimension.width} x ${dimension.height}`}</>
        );
      },
    },
    {
      title: t("label.weight"),
      dataIndex: "weight",
      render: (weight: string) => <>{`${weight} kg`}</>,
    },
  ];

  const RowOne = () => {
    return (
      <>
        <Col span={6}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.remarks")} </label>
            </Col>
            <Col span={24}>
              <div>
                {orderDetails?.remarks ? orderDetails.remarks : "No remarks"}
              </div>
            </Col>
          </Row>
        </Col>
      </>
    );
  };

  const RowTwo = () => {
    return (
      <Col span={24}>
        <DataTable
          columns={columns}
          dataSource={orderDetails?.childrenOrdersData}
        />
      </Col>
    );
  };

  return (
    <div className="dm-put-content">
      <Row gutter={[16, 24]}>
        <RowOne />
        <RowTwo />
      </Row>
    </div>
  );
};

const OrderHistory = ({ orderVersion }) => {
  const { t } = useTranslation();

  // most formatting is done in order_version_history.ts
  const baseColumns: any = [
    {
      title: t("label.date").toLocaleUpperCase(),
      dataIndex: "date",
      width: 100,
      ellipsis: true,
      render: (text: any) => {
        return (
          <div>
            {`${moment(text).format("DD-MM-YYYY")} | ${moment(text).format(
              "hh:mm a",
            )}` || "-"}
          </div>
        );
      },
    },
    {
      title: t("label.type").toLocaleUpperCase(),
      dataIndex: "type",
      width: 100,
      ellipsis: true,
    },
    {
      title: t("label.flaggedBy").toLocaleUpperCase(),
      dataIndex: "updatedBy",
      width: 100,
      ellipsis: true,
    },
    {
      title: t("label.details").toLocaleUpperCase(),
      dataIndex: "",
      ellipsis: true,
      render: (_: any, record: any) => {
        return record?.details?.map((detail, index) => {
          return <div key={index}>{detail}</div>;
        });
      },
    },
    // {
    //   title: t("label.image").toLocaleUpperCase(),
    //   dataIndex: ["data", "details", "image"],
    //   width: 100,
    //   ellipsis: true,
    //   render: (_: any, record: any) => {
    //     return (
    //       <React.Fragment>
    //         <div>
    //           {record.data.details.image ? (
    //             <a className="imageTag">{record.data.details.image}</a>
    //           ) : (
    //             <>{"-"}</>
    //           )}
    //         </div>
    //       </React.Fragment>
    //     );
    //   },
    // },
  ];

  return (
    <div className="dm-put-content">
      <Row gutter={[16, 24]}>
        <Col span={24}>
          <label className="title"> {t("label.orderVersionHistory")} </label>
        </Col>
        <Col span={24}>
          <DataTable
            scroll={{ x: true }}
            columns={baseColumns}
            dataSource={orderVersion}
          />
        </Col>
      </Row>
    </div>
  );
};

const OrderDetails: FC<any> = (props) => {
  const { orderDetails, orderVersion, isLoading, handleEditDeliveryDate, handleEditPickupDateTime } =
    props || {};

  const commonProps = {
    handleEditDeliveryDate,
    handleEditPickupDateTime
  };

  return (
    <div className="order-details">
      {isLoading ? (
        <div className="loading-container">
          <Spin size="large" indicator={<LoadingOutlined />} />
        </div>
      ) : (
        <>
          <OrderInformation {...commonProps} orderDetails={orderDetails} />
          {orderDetails.orderType !== ParcelTypeEnums.SPLIT ? (
            <OrderSpecifications orderDetails={orderDetails} />
          ) : (
            <OrderSpecificationsSplitShipment orderDetails={orderDetails} />
          )}
          <OrderHistory orderVersion={orderVersion} />
        </>
      )}
    </div>
  );
};

export default OrderDetails;
